import { clinicalVideosConstant } from '../constants/clinicalVideo.constant';
import appConfig from '../../config/config';

import { generateUtmExt, log } from '../../common/common';
import { logoutUser } from './login.action';
import axiosInstance from '../helper/axiosInstance';
const url = appConfig.apiLoc;

export const getClinicalVideos = (pagination, to, callback, extraType = '') => {
  return async (dispatch) => {
    axiosInstance
      .get(`knwlg/archiveVideoList?from=${pagination}&to=${to}${extraType}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch({
            type: clinicalVideosConstant.GET_ARCHIVE_VIDEO_LIST_SUCCESS,
            payload: response.data
          });
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');

        dispatch({
          type: clinicalVideosConstant.GET_ARCHIVE_VIDEO_LIST_FALIURE,
          payload: error
        });
      });
  };
};
export const getRelatedClinicalVideos = (id, pagination, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`knwlg/archiveVideoList?type_id=${id}&from=${pagination}&to=5`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch({
            type: clinicalVideosConstant.GET_RELATED_VIDEO_LIST_SUCCESS,
            payload: response.data
          });
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');

        dispatch({
          type: clinicalVideosConstant.GET_RELATED_VIDEO_LIST_FAILURE,
          payload: error
        });
      });
  };
};
export const getClinicalVideoswithSpecs = (specs, pagination, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`${url}knwlg/archiveVideoList?from=${pagination}&to=5&spIds=${specs}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch({
            type: clinicalVideosConstant.GET_ARCHIVE_VIDEO_WITH_SPECIALITIES_SUCCESS,
            payload: response.data
          });
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');

        dispatch({
          type: clinicalVideosConstant.GET_ARCHIVE_VIDEO_WITH_SPECIALITIES_FALIURE,
          payload: error
        });
      });
  };
};
export const getSpecialityVideos = (specs, pagination, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`knwlg/archiveVideoList?from=${pagination}&to=10&spIds=${specs}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const getClinicalDetails = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`knwlg/archiveVideoDetail?type_id=${id}${generateUtmExt()}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch({
            type: clinicalVideosConstant.GET_DETAILS_SUCCESS,
            payload: response.data
          });
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');

        dispatch({
          type: clinicalVideosConstant.GET_DETAILS_FAILURE,
          payload: error
        });
      });
  };
};
//knwlg/archiveVideoDetail?type_id=
